import { DateRange } from '../../models/date-range/date-range.model';
import { dateToIsoWeek } from '../date-to-iso-week/date-to-iso-week.function';

/**
 * @name dateRangeToIsoWeek
 * @category Common Helpers
 * @summary Format DateRange to ISO 8601 week notation
 *
 * @description
 * Convert a DateRange object to its ISO 8601 week notation format (YYYY-Www) based on its start date.
 *
 * @param dateRange - DateRange object
 * @returns ISO 8601 week notation string (e.g., '2026-W04')
 *
 * @example
 * // Convert DateRange to string '2026-W04':
 * const dateRange = new DateRange(new Date(2026, 0, 19), new Date(2026, 0, 25));
 * const result = dateRangeToIsoWeek(dateRange)
 * //=> '2026-W04'
 */
export function dateRangeToIsoWeek(dateRange: DateRange): string {
  return dateToIsoWeek(dateRange.start);
}
